const Form085TC = {
    stepName: {
        importantNotes: "重要事項",
        schoolInformation: "學校資料",
        studentContestants: "參賽學生",
        personalParticularsOfCoachTeacher: "指導教師資料",
        confirmation: "確認",
    },
    label: {
        statement: {
            title: {
                title1: "個人資料收集聲明",
                title2: "教育局會利用本表格所載的個人資料，作以下其中一種或多種用途︰",
            },
            // note: {
            //     a: "教育局會利用本表格所載的個人資料，用作處理是次比賽的報名、聯絡及統計分析的用途。",
            //     b: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
            //     c: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局/部門/機構披露作上述用途。",
            //     d: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
            //     e: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需透過電郵 (",
            //     f: "exoge@edb.gov.hk",
            //     g: ") 向教育局資優教育組提出。",
            //     h: "教育局承諾會確保一切個人資料均依照 《個人資料（私隱）條例》的有關條文處理。詳情請參閱《",
            //     i: "教育局—私隱政策及實務聲明",
            //     j: "》。",
            //     k: "如有查詢，請致電 3698 3493 或電郵至 ",
            //     k1:" 與魯泳斌先生聯絡。",
            //     l: "https://www.edb.gov.hk/attachment/tc/about-edb/info/privacy-statement/EDB_PDPO_c.pdf",
            //     m: "學校須通知學生及其家長／監護人，在比賽過程中，教育局及獲教育局授權的人士／團體將有機會進行拍攝或錄影，學生將有可能被拍攝或錄影。教育局可能會利用有關的照片或影片，以印刷或數碼形式作推廣用途。若學校或家長／監護人對有關安排有任何疑問，請電郵至",
            //     n: "cdoge6@edb.gov.hk",
            //     o: "。",
            // },
            noteList: [
                {
                    text: "教育局會利用本表格所載的個人資料，用作處理是次比賽的報名、聯絡及統計分析的用途。",
                },
                {
                    text: "申請人必須在本表格上填寫個人資料。申請人如不提供這些資料，申請的處理工作及結果或會受影響。",
                },
                {
                    text: "本表格所蒐集的個人資料，或會向其他獲授權的政府決策局／部門／機構披露作上述用途。",
                },
                {
                    text: "根據《個人資料(私隱)條例》，第18和22條及附表1保障資料第6原則的規定，你有權要求查閱及改正你的個人資料。要求查閱的權利，包括要求提供本表格所載個人資料的副本，但須繳付費用。",
                },
                {
                    text: '如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需透過電郵 (<a href="mailto: exoge@edb.gov.hk">exoge@edb.gov.hk</a>) 向教育局資優教育組提出。',
                },
                {
                    text: '教育局承諾會確保一切個人資料均依照 《個人資料（私隱）條例》的有關條文處理。詳情請參閱《<a style="color: blue" href="https://www.edb.gov.hk/attachment/tc/about-edb/info/privacy-statement/EDB_PDPO_c.pdf" target="_blank" rel="noopener noreferrer">教育局—私隱政策及實務聲明</a>》。',
                },
                {
                    text: '如有查詢，請致電 3698 3493 或電郵至 <a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a> 與魯泳斌先生聯絡。',
                },
                {
                    text: '學校須通知學生及其家長／監護人，在比賽過程中，教育局及獲教育局授權的人士／團體將有機會進行拍攝或錄影，學生將有可能被拍攝或錄影。教育局可能會利用有關的照片或影片，以印刷或數碼形式作推廣用途。若學校或家長／監護人對有關安排有任何疑問，請電郵至<a href="mailto: cdoge6@edb.gov.hk">cdoge6@edb.gov.hk</a>。',
                },
            ]
        },
        schoolInfo: {
            schoolName: "學校名稱(英文)",
            schoolNameOfChinese: "學校名稱(中文)",
            schoolTelephoneNumber: "學校聯絡電話",
            schoolFaxNumber: "學校傳真號碼",
        },
        studentContestants: {
            nameInEnglish: "姓名(英文)",
            nameInChinese: "姓名(中文)(如不適用，請填上“NIL”)",
            level: "年級",
            levelValue: {
                primary1: "小四",
                primary2: "小五",
                primary3: "小六",
            },
        },
        instructorInfo: {
            nameInEnglish: "姓名(英文)",
            nameInChinese: "姓名(中文)",
            mobileNumber: "手提電話號碼",
            emailAddress: "電郵地址",
            nameOfTheSchoolHead: "校長姓名",
        },
        title: {
            title1: "參賽資格",
            title2: "備註",
        },
        note: {
            note1: "1. 每間學校只能派出一隊隊伍參賽。",
            note2: "2. 每隊必須有四人。",
            note3: "3. 參賽學生必須是小四至小六學生，各級人數不限。",
            note4: "(1) 比賽由教育局資優教育組及香港教育工作者聯會合辦。",
            // note5: "(2)	如有任何查詢請致電3698 3493或電郵至 ",
            // note5a: " 與教育局資優教育組魯泳斌先生聯絡。",
            note6: "(2)	大會將於各項比賽及頒獎禮中進行攝影及錄影。",
            note7: "(3) 請正確填寫所有資料。有關資料將會印於相關得獎證書及資料匯編上。",
            note8: "(4)	所有本比賽的相關資料，包括初賽、決賽及頒獎禮的成績及安排，會上載至本比賽網頁 ",
            note9: "(5)	參賽學校需要經常瀏覽本比賽網頁，查閱比賽的最新資訊。教育局不會再另行通知。",
            note10: "。",
            lianjie: "http://www.edb.gov.hk/tc/CPS-Pri",
        },
        errorMsg: {
            nameOfSchoolEN: "學校名稱(英文)",
            nameOfSchoolCH: "學校名稱(中文)",
            tel: "請輸入一個有效的電話號碼",
            fax: "請輸入一個有效的傳真號碼",
            nameInEnglish: "姓名(英文)",
            nameInChinese: "姓名(中文)",
            nameOfEnglish: "姓名(英文)",
            nameOfChinese: "姓名(中文)",
            mobileTel: "請輸入一個有效的手提電話號碼",
            required: "該字段必填",
            numberType: "該字段必須是'数字'類型",
            min8: "最小值 = 8",
            max20: "最大值 = 20",
            characterType: "字母 / 字母數字 / 中文",
            min4: "每隊必須有四名學生",
            max2: "一隊中最多只有兩名中二學生",
            emailType: "需要匹配電子郵件規則",
        },
    },
};
export default Form085TC;
